/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var TCP_CONNECTION = 'TcpList';
exports.TCP_CONNECTION = TCP_CONNECTION;
var HTTP_REQUEST = 'HttpList';
exports.HTTP_REQUEST = HTTP_REQUEST;
var TRACK_SWITCH = 'RepSwitchList';
exports.TRACK_SWITCH = TRACK_SWITCH;
var BUFFER_LEVEL = 'BufferLevel';
exports.BUFFER_LEVEL = BUFFER_LEVEL;
var BUFFER_STATE = 'BufferState';
exports.BUFFER_STATE = BUFFER_STATE;
var DVR_INFO = 'DVRInfo';
exports.DVR_INFO = DVR_INFO;
var DROPPED_FRAMES = 'DroppedFrames';
exports.DROPPED_FRAMES = DROPPED_FRAMES;
var SCHEDULING_INFO = 'SchedulingInfo';
exports.SCHEDULING_INFO = SCHEDULING_INFO;
var REQUESTS_QUEUE = 'RequestsQueue';
exports.REQUESTS_QUEUE = REQUESTS_QUEUE;
var MANIFEST_UPDATE = 'ManifestUpdate';
exports.MANIFEST_UPDATE = MANIFEST_UPDATE;
var MANIFEST_UPDATE_STREAM_INFO = 'ManifestUpdatePeriodInfo';
exports.MANIFEST_UPDATE_STREAM_INFO = MANIFEST_UPDATE_STREAM_INFO;
var MANIFEST_UPDATE_TRACK_INFO = 'ManifestUpdateRepresentationInfo';
exports.MANIFEST_UPDATE_TRACK_INFO = MANIFEST_UPDATE_TRACK_INFO;
var PLAY_LIST = 'PlayList';
exports.PLAY_LIST = PLAY_LIST;
var DVB_ERRORS = 'DVBErrors';
exports.DVB_ERRORS = DVB_ERRORS;
//# sourceMappingURL=DashMetricsList.js.map



//////////////////
// WEBPACK FOOTER
// ./~/dashjs/build/es5/src/dash/constants/DashMetricsList.js
// module id = 546
// module chunks = 0 1 2 3